export class EnrollParents {
  surName: string = '';
  firstName: string = '';
  patronymic: string = '';
  address: string = '';
  phone: string = '';
  iin: string = '';
  citizenship: number;
  has_iin: number = 1;
  id_number: string = '';
  id_begin_date: Date;
  id_give_organ: string = '';
  customer: boolean = false;
  work_place: string = '';
  work_position: string = '';
  main_guardian: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-parents.ts